import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TheCycleverseTheme } from "src/theme";

const useStyles = (props: { backgroundImageDesktop: string; backgroundImageMobile: string }) =>
  makeStyles((theme: TheCycleverseTheme) => ({
    header: {
      height: "75vh",
      paddingTop: "15vh",
      color: theme.palette.secondary.main,
      textAlign: "center",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundColor: "#000",
      backgroundImage: `url('${props.backgroundImageDesktop}')`,
      [theme.breakpoints.down("xs")]: {
        paddingTop: "8vh",
        backgroundImage: `url('${props.backgroundImageMobile}')`,
      },
    },
    headerContent: {
      maxWidth: 500,
      display: "inline-block",
      [theme.breakpoints.down("xs")]: {
        paddingLeft: theme.globalMarginMobile,
        paddingRight: theme.globalMarginMobile,
      },
    },
    title: {
      ...theme.headline2,
    },
    intro: {
      fontFamily: theme.highlightFontFamily,
      fontSize: 36,
      fontWeight: 900,
      marginTop: 0,
      "& span": {
        display: "inline-block",
        whiteSpace: "pre-wrap",
      },
      [theme.breakpoints.down("sm")]: {
        maxWidth: 400,
      },
    },
  }))();

export type HeaderProps = {
  title: any;
  intro: any;
  backgroundImageDesktop: string;
  backgroundImageMobile: string;
  className?: string;
};

const Header: FC<HeaderProps> = ({ title, intro, backgroundImageDesktop, backgroundImageMobile, className }) => {
  const classes = useStyles({ backgroundImageDesktop, backgroundImageMobile });
  return (
    <div className={`${className ? className : ""} ${classes.header}`}>
      <div className={classes.headerContent}>
        <p className={classes.title}>{title}</p>
        <p className={classes.intro}>{intro}</p>
      </div>
    </div>
  );
};

export default Header;
